import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/data";

export default function Services() {
  return (
    <section data-testid="services-section" id="services" className="section-pad bg-sand">
      <div className="container-pad mx-auto max-w-7xl">
        <div className="max-w-3xl">
          <span className="eyebrow">
            <span className="w-8 h-px bg-teal-500" />
            Our Services
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-navy tracking-tight mt-5 leading-[1.15]">
            Transportation services <strong className="font-bold text-teal-600">designed around care.</strong>
          </h2>
          <p className="mt-5 text-base md:text-lg text-navy/65 leading-relaxed font-light">
            From wheelchair-accessible rides to long-distance medical transport, every service is built around
            the unique needs of your appointment, condition, and comfort.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6 mt-14">
          {SERVICES.map((s, idx) => {
            const Icon = Icons[s.icon] || Icons.Heart;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="card-soft p-7 lg:p-8 group hover:-translate-y-1 cursor-pointer relative overflow-hidden"
                style={{ animationDelay: `${idx * 60}ms` }}
              >
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-teal-500 to-teal-700 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
                <div className="w-14 h-14 rounded-2xl bg-teal-500/10 flex items-center justify-center text-teal-600 group-hover:bg-teal-500 group-hover:text-white transition-all">
                  <Icon className="w-7 h-7" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-xl font-semibold text-navy mt-6 leading-snug">{s.title}</h3>
                <p className="text-navy/65 mt-3 text-sm leading-relaxed">{s.short}</p>
                <div className="flex items-center gap-1.5 mt-6 text-teal-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  Learn more <ArrowUpRight className="w-4 h-4" />
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-14 text-center">
          <p className="text-navy/70 mb-5">Need a custom transportation plan?</p>
          <a href="#consultation" className="btn-secondary">Book Free Consultation</a>
        </div>
      </div>
    </section>
  );
}
